/*import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.css";
*/
import { ConnectedRouter } from "connected-react-router";
import { createBrowserHistory } from "history";
import * as React from "react";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import * as ReactDOM from "react-dom";
import TagManager from "react-gtm-module";
import { HeadProvider } from "react-head";
import { Provider } from "react-redux";
import App from "./App";
import configureStore from "./store/configureStore";

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href") as string;
const history = createBrowserHistory({ basename: baseUrl });

let base = "https://cca.alanboswell.com";

const urlHost = document.location.hostname;
let gtm = "GTM-5KTB65"; // prod

if (urlHost === "cca.devsite") {
    base = "http://cca.devsite";
    gtm = "GTM-5KTB65";
} else if (urlHost === "beta-cca.alanboswell.com") {
    base = "https://beta-cca.alanboswell.com";
    gtm = "GTM-5KTB65"; 
} else if (urlHost === "localhost") {
    base = "https://localhost:5004";
    gtm = "GTM-5KTB65";
}

export const ccaHandlerAPIUrl = base;


// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(history);

const tagManagerArgs = {
    gtmId: gtm
}

TagManager.initialize(tagManagerArgs);

const render = () => ReactDOM.render(
    <HeadProvider>
        
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <App />
            </ConnectedRouter>
        </Provider>
    </HeadProvider>,
    document.getElementById("root"));


render();
